import { apiUrl2 } from '../../../settings'

export const getAgentMeetingUrl = () => {
  return apiUrl2 + '/getAllMeetings'
}
export const updateAgentMeetingUrl = () => {
  return apiUrl2 + '/updateAgentMeetings'
}